import * as types from "../types";
import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { ActionsCreators } from "../../actions";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {
    GetFormsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {

        secondary ? dispatch({ type: types.GET_FORMS_SECONDARY_COMPLETED, payload: null }) : dispatch({ type: types.GET_FORMS_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Form/OrganizationForms/" + store().currentuser.currentorganization.id + "?"
                + "pageNumber=" + pageNumber
                + "&pageSize=" + pageSize
                + (sortExpression ? "&sortExpression=" + sortExpression : "")
                + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            secondary ? dispatch({ type: types.GET_FORMS_SECONDARY_COMPLETED, payload: data }) : dispatch({ type: types.GET_FORMS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetSecondaryFormsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => (dispatch) => {
        dispatch(ActionsCreators.GetFormsList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, true));
    },

    GetForm: (id, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Form/" + id, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    DeleteForm: (Id, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Form/" + Id, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.formDeleted);
            if (onSuccess) {onSuccess(data);}
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    EditForm: (changedDisplayGroup, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Form/" + store().currentuser.currentorganization.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(changedDisplayGroup),
            method: "PUT"
        }).then((data) => {
            onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    CreateForm: (newDisplayGroup, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Form/" + store().currentuser.currentorganization.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newDisplayGroup),
            method: "POST"
        }).then((data) => {
            onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    DuplicateForm: (id, name, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Form/Duplicate/" + id + (name ? "?name=" + name : ""), {
            method: "GET"
        }).then((data) => {
            toast.success(strings.formDuplicated);
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetParticipations: (id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Form/Participation/" + id, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    }

};
